// extracted by mini-css-extract-plugin
export default {"divLeft":"navigate_divLeft__a3iJk","disabled":"navigate_disabled__z6Bxp","divRight":"navigate_divRight__TpYQV"};